(function () {
  'use strict';

  var SLIDER = '[data-tcv-slider]';
  var TOGGLE = '[data-tcvc-show-all-colours]';
  var ROOT = '.rf-tcv';
  var SHOW_ALL_CLASS = 'rf-tcvc--show-all-colours';
  var STORAGE_PREFIX = 'rf_tcvc_show_all_colours_';

  function sliders() {
    return Array.prototype.slice.call(document.querySelectorAll(SLIDER)).filter(function (slider) {
      return !slider.closest('.rf-tcv__group--collapsed');
    });
  }

  function collectionKey() {
    var control = document.querySelector('[data-tcv-collection]');
    var handle = control && control.getAttribute('data-tcv-collection');
    if (!handle) {
      var select = document.querySelector('#rf-nav-collection-select');
      var selected = select && select.value;
      handle = selected ? selected.split('/').pop() : window.location.pathname.split('/').pop();
    }
    return STORAGE_PREFIX + (handle || 'collection');
  }

  function showAllEnabled() {
    var root = document.querySelector(ROOT);
    return !!(root && root.classList.contains(SHOW_ALL_CLASS));
  }

  function setShowAll(enabled, persist) {
    var root = document.querySelector(ROOT);
    var button = document.querySelector(TOGGLE);
    if (!root || !button) return;

    root.classList.toggle(SHOW_ALL_CLASS, enabled);
    button.setAttribute('aria-pressed', enabled ? 'true' : 'false');
    button.textContent = enabled ? 'Use colour slider' : 'Show all colours';

    if (persist !== false) {
      try {
        window.localStorage.setItem(collectionKey(), enabled ? '1' : '0');
      } catch (e) {}
    }

    if (!enabled) {
      sliders().forEach(function (slider) {
        var viewport = slider.querySelector('[data-tcv-samples]');
        if (viewport) viewport.scrollLeft = 0;
        sync(slider);
      });
    } else {
      sliders().forEach(function (slider) {
        var prev = slider.querySelector('[data-tcv-slider-prev]');
        var next = slider.querySelector('[data-tcv-slider-next]');
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
      });
    }
  }

  function restoreMode() {
    var enabled = false;
    try {
      enabled = window.localStorage.getItem(collectionKey()) === '1';
    } catch (e) {}
    setShowAll(enabled, false);
  }

  function sync(slider) {
    if (showAllEnabled()) {
      var p = slider.querySelector('[data-tcv-slider-prev]');
      var n = slider.querySelector('[data-tcv-slider-next]');
      if (p) p.hidden = true;
      if (n) n.hidden = true;
      return;
    }

    var viewport = slider.querySelector('[data-tcv-samples]');
    var prev = slider.querySelector('[data-tcv-slider-prev]');
    var next = slider.querySelector('[data-tcv-slider-next]');
    if (!viewport || (!prev && !next)) return;

    var overflowing = viewport.scrollWidth > viewport.clientWidth + 2;
    var atStart = viewport.scrollLeft <= 2;
    var atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;

    if (prev) {
      prev.hidden = !overflowing || atStart;
      prev.disabled = !overflowing || atStart;
    }
    if (next) {
      next.hidden = !overflowing || atEnd;
      next.disabled = !overflowing || atEnd;
    }
  }

  function predictedProductWidth(rowWidth) {
    var ratio = 0.40;
    if (window.innerWidth <= 1023) {
      ratio = 0.46;
    } else if (window.innerWidth <= 1199) {
      ratio = 0.41;
    }
    return Math.max(375, rowWidth * ratio);
  }

  function configuredSwatchWidth(row) {
    var root = row.closest(ROOT);
    if (!root) return 0;
    var styles = window.getComputedStyle(root);
    var token = window.innerWidth >= 1200
      ? '--rf-tcvc-colour-swatch-desktop'
      : '--rf-tcvc-colour-swatch-tablet';
    var configured = parseFloat(styles.getPropertyValue(token));
    if (configured > 0) return configured;

    var sample = row.querySelector('.rf-tcvb__sample');
    return sample ? sample.getBoundingClientRect().width : 0;
  }

  function syncColourRowLayout(row) {
    if (!row || window.innerWidth < 768) {
      if (row) row.classList.remove('rf-tcvb__row--stack-colours');
      return;
    }

    var sample = row.querySelector('.rf-tcvb__sample');
    if (!sample) {
      row.classList.remove('rf-tcvb__row--stack-colours');
      return;
    }

    var rowWidth = row.getBoundingClientRect().width;
    var productWidth = predictedProductWidth(rowWidth);
    var middleGap = 24;
    var colourWidth = Math.max(0, rowWidth - productWidth - middleGap);
    var swatchWidth = configuredSwatchWidth(row);
    var swatchGap = 8;
    var columns = swatchWidth > 0
      ? Math.floor((colourWidth + swatchGap) / (swatchWidth + swatchGap))
      : 0;

    row.classList.toggle('rf-tcvb__row--stack-colours', columns < 3);
  }

  function syncColourLayouts() {
    Array.prototype.slice.call(document.querySelectorAll('tr.rf-tcvb__row--has-colours'))
      .filter(function (row) { return !row.closest('.rf-tcv__group--collapsed'); })
      .forEach(syncColourRowLayout);
  }

  function syncAll() {
    sliders().forEach(sync);
    syncColourLayouts();
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest(TOGGLE);
    if (toggle) {
      event.preventDefault();
      setShowAll(!showAllEnabled(), true);
      return;
    }

    var button = event.target.closest('[data-tcv-slider-prev], [data-tcv-slider-next]');
    if (!button || showAllEnabled()) return;

    var slider = button.closest(SLIDER);
    var viewport = slider && slider.querySelector('[data-tcv-samples]');
    if (!viewport) return;

    event.preventDefault();
    var direction = button.hasAttribute('data-tcv-slider-prev') ? -1 : 1;
    var amount = Math.max(viewport.clientWidth * 0.8, 180);
    viewport.scrollBy({ left: direction * amount, behavior: 'smooth' });
  });

  var colourScrollRaf = 0;
  var pendingColourSlider = null;
  document.addEventListener('scroll', function (event) {
    if (showAllEnabled()) return;
    var viewport = event.target && event.target.closest ? event.target.closest('[data-tcv-samples]') : null;
    if (!viewport) return;
    pendingColourSlider = viewport.closest(SLIDER);
    if (!pendingColourSlider || colourScrollRaf) return;
    colourScrollRaf = window.requestAnimationFrame(function () {
      colourScrollRaf = 0;
      if (pendingColourSlider) sync(pendingColourSlider);
      pendingColourSlider = null;
    });
  }, { capture: true, passive: true });

  var resizeRaf = 0;
  window.addEventListener('resize', function () {
    if (resizeRaf) return;
    resizeRaf = window.requestAnimationFrame(function () {
      resizeRaf = 0;
      syncAll();
    });
  }, { passive: true });

  document.addEventListener('DOMContentLoaded', function () {
    restoreMode();
    syncAll();
  });

  document.addEventListener('rf:collection-group-open', function (event) {
    var group = event.detail && event.detail.group;
    if (!group) return;
    window.requestAnimationFrame(function () {
      group.querySelectorAll(SLIDER).forEach(sync);
      group.querySelectorAll('tr.rf-tcvb__row--has-colours').forEach(syncColourRowLayout);
    });
  });

  document.addEventListener('shopify:section:load', function () {
    restoreMode();
    syncAll();
  });

  var observerTarget = document.querySelector('.rf-tcv');
  if (observerTarget) {
    var observerRaf = 0;
    var observer = new MutationObserver(function (mutations) {
      // Ignore unrelated DOM additions (modals, badges, app widgets).
      var collectionChanged = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('[data-tcv-slider], #product-grid, .rf-tcv__group') ||
            (node.querySelector && node.querySelector('[data-tcv-slider], #product-grid, .rf-tcv__group')));
        });
      });
      if (!collectionChanged || observerRaf) return;
      observerRaf = window.requestAnimationFrame(function () {
        observerRaf = 0;
        restoreMode();
        syncAll();
      });
    });
    observer.observe(observerTarget, { childList: true, subtree: true });
  }
})();

/* V2C colour image lightbox */
(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function ensureLightbox() {
    var existing = document.querySelector('[data-tcvc-lightbox]');
    if (existing) return existing;

    var overlay = document.createElement('div');
    overlay.className = 'rf-tcvc-lightbox';
    overlay.setAttribute('data-tcvc-lightbox', '');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Colour image preview');
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="rf-tcvc-lightbox__dialog">' +
        '<button type="button" class="rf-tcvc-lightbox__close" data-tcvc-lightbox-close aria-label="Close image preview">&times;</button>' +
        '<img class="rf-tcvc-lightbox__image" data-tcvc-lightbox-image alt="">' +
        '<div class="rf-tcvc-lightbox__caption" data-tcvc-lightbox-caption></div>' +
      '</div>';
    document.body.appendChild(overlay);
    return overlay;
  }

  function closeLightbox() {
    var overlay = document.querySelector('[data-tcvc-lightbox]');
    if (!overlay) return;
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-tcvc-colour-lightbox]');
    if (swatch) {
      event.preventDefault();
      var overlay = ensureLightbox();
      var image = overlay.querySelector('[data-tcvc-lightbox-image]');
      var caption = overlay.querySelector('[data-tcvc-lightbox-caption]');
      var name = swatch.getAttribute('data-colour-name') || '';
      var productName = swatch.getAttribute('data-product-name') || '';
      var boardSize = swatch.getAttribute('data-board-size') || '';
      image.src = swatch.getAttribute('href');
      image.alt = name;
      caption.innerHTML =
        '<div class="rf-tcvc-lightbox__colour">' + escapeHtml(name) + '</div>' +
        (productName ? '<div class="rf-tcvc-lightbox__product">' + escapeHtml(productName) + '</div>' : '') +
        (boardSize ? '<div class="rf-tcvc-lightbox__size">' + escapeHtml(boardSize) + '</div>' : '');
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      return;
    }

    if (event.target.matches('[data-tcvc-lightbox], [data-tcvc-lightbox-close]')) {
      event.preventDefault();
      closeLightbox();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeLightbox();
  });
})();

/* V2C selected-products enquiry modal */
(function () {
  'use strict';

  var successContextKey = 'rf-online-enquiry-success-context:v1';

  function modal() {
    return document.querySelector('[data-tcvc-enquiry-modal]');
  }

  function form() {
    var root = modal();
    return root && root.querySelector('form');
  }

  function selectedRows() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-tcv-compare-toggle]:checked'))
      .map(function (checkbox) { return checkbox.closest('tr.rf-tcvb__row'); })
      .filter(Boolean);
  }

  function updateToolbarButton() {
    var button = document.querySelector('[data-tcvc-enquiry-toolbar]');
    if (!button) return;
    var count = selectedRows().length;
    var badge = button.querySelector('[data-tcvc-enquiry-count]');
    if (badge) badge.textContent = String(count);
    button.disabled = count === 0;
  }

  function closeModal() {
    var root = modal();
    if (!root) return;
    root.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function revealPostedSuccess() {
    var root = modal();
    var success = root && root.querySelector('[data-tcvc-enquiry-success]');
    if (!root || !success) return;

    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(function () { success.focus(); }, 50);

    var detail = null;
    try {
      detail = JSON.parse(sessionStorage.getItem(successContextKey) || 'null');
    } catch (_error) {
      detail = null;
    }

    if (detail) {
      document.dispatchEvent(new CustomEvent('rf:enquiry:submitted', { detail: detail }));
    }

    try {
      var currentUrl = new URL(window.location.href);
      if (currentUrl.searchParams.has('contact_posted')) {
        currentUrl.searchParams.delete('contact_posted');
        if (currentUrl.hash === '#rf_product_enquiry_form_v2c_collection') currentUrl.hash = '';
        window.history.replaceState({}, '', currentUrl.pathname + currentUrl.search + currentUrl.hash);
      }
    } catch (_error) {
    }

    window.setTimeout(function () {
      try {
        sessionStorage.removeItem(successContextKey);
      } catch (_error) {
      }
    }, 0);
  }

  function productData(row) {
    var title = row.getAttribute('data-tcvc-product-title') || '';
    var url = row.getAttribute('data-tcvc-product-url') || '';
    var colours = [];
    var seen = {};
    row.querySelectorAll('[data-colour-name]').forEach(function (swatch) {
      var name = (swatch.getAttribute('data-colour-name') || '').trim();
      var key = name.toLowerCase();
      if (!name || seen[key]) return;
      seen[key] = true;
      var image = swatch.querySelector('img');
      colours.push({
        name: name,
        src: image ? (image.currentSrc || image.getAttribute('src') || '') : ''
      });
    });
    return { title: title, url: url, colours: colours };
  }

  function updateColourSummary(group) {
    if (!group) return;
    var label = group.querySelector('[data-tcvc-colour-summary-label]');
    if (!label) return;
    var count = group.querySelectorAll('input[type="checkbox"]:checked').length;
    label.textContent = count ? count + ' selected' : 'Select colours';
  }

  function syncSelectedColours(root) {
    var hidden = root.querySelector('[data-tcvc-enquiry-colour-field]');
    if (!hidden) return;
    var groups = [];
    root.querySelectorAll('[data-tcvc-enquiry-product-group]').forEach(function (group) {
      var product = group.getAttribute('data-product-title') || '';
      var selected = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"]:checked'))
        .map(function (input) { return input.value; });
      if (selected.length) groups.push(product + ': ' + selected.join(', '));
      updateColourSummary(group);
    });
    hidden.value = groups.join(' | ');
  }

  function renderProducts(root, products) {
    var summary = root.querySelector('[data-tcvc-enquiry-product]');
    var selectedWrap = root.querySelector('[data-tcvc-enquiry-selected-products]');
    var colourWrap = root.querySelector('[data-tcvc-enquiry-colour-options]');
    var fieldset = root.querySelector('[data-tcvc-enquiry-colours]');
    if (!summary || !selectedWrap || !colourWrap || !fieldset) return;

    summary.textContent = products.length === 1 ? products[0].title : products.length + ' products selected';
    selectedWrap.innerHTML = '';
    colourWrap.innerHTML = '';

    products.forEach(function (product, pIndex) {
      var item = document.createElement('div');
      item.className = 'rf-tcvc-enquiry__selected-product';
      item.textContent = product.title;
      selectedWrap.appendChild(item);

      if (product.colours.length) {
        var group = document.createElement('div');
        group.className = 'rf-tcvc-enquiry__product-group';
        group.setAttribute('data-tcvc-enquiry-product-group', '');
        group.setAttribute('data-product-title', product.title);

        var heading = document.createElement('div');
        heading.className = 'rf-tcvc-enquiry__product-group-title';
        heading.textContent = product.title;
        group.appendChild(heading);

        var picker = document.createElement('details');
        picker.className = 'rf-tcvc-enquiry__colour-picker';

        var pickerSummary = document.createElement('summary');
        pickerSummary.className = 'rf-tcvc-enquiry__colour-picker-summary';

        if (product.colours[0].src) {
          var summaryIcon = document.createElement('img');
          summaryIcon.className = 'rf-tcvc-enquiry__colour-summary-icon';
          summaryIcon.src = product.colours[0].src;
          summaryIcon.alt = '';
          pickerSummary.appendChild(summaryIcon);
        }

        var summaryText = document.createElement('span');
        summaryText.className = 'rf-tcvc-enquiry__colour-summary-label';
        summaryText.setAttribute('data-tcvc-colour-summary-label', '');
        summaryText.textContent = 'Select colours';
        pickerSummary.appendChild(summaryText);

        var chevron = document.createElement('span');
        chevron.className = 'rf-tcvc-enquiry__colour-summary-chevron';
        chevron.setAttribute('aria-hidden', 'true');
        chevron.textContent = '⌄';
        pickerSummary.appendChild(chevron);
        picker.appendChild(pickerSummary);

        var choices = document.createElement('div');
        choices.className = 'rf-tcvc-enquiry__colour-options rf-tcvc-enquiry__colour-options--dropdown';

        product.colours.forEach(function (colour, cIndex) {
          var label = document.createElement('label');
          label.className = 'rf-tcvc-enquiry__colour-option';

          var input = document.createElement('input');
          input.type = 'checkbox';
          input.name = 'rf-tcvc-colour-choice';
          input.value = colour.name;
          input.id = 'rf-tcvc-colour-' + pIndex + '-' + cIndex;

          if (colour.src) {
            var swatch = document.createElement('img');
            swatch.className = 'rf-tcvc-enquiry__colour-option-icon';
            swatch.src = colour.src;
            swatch.alt = '';
            label.appendChild(swatch);
          }

          var text = document.createElement('span');
          text.textContent = colour.name;

          label.appendChild(input);
          label.appendChild(text);
          choices.appendChild(label);
        });

        picker.appendChild(choices);
        group.appendChild(picker);
        colourWrap.appendChild(group);
      }
    });

    fieldset.hidden = !colourWrap.children.length;
  }

  function openModal() {
    var root = modal();
    var enquiryForm = form();
    var rows = selectedRows();
    if (!root || !enquiryForm || !rows.length) return;

    var products = rows.map(productData);
    var titles = products.map(function (p) { return p.title; });
    var urls = products.map(function (p) { return p.url; }).filter(Boolean);

    var page = root.querySelector('[data-tcvc-enquiry-page]');
    var product = root.querySelector('[data-tcvc-enquiry-product-field]');
    var sourceUrl = root.querySelector('[data-tcvc-enquiry-source-url]');
    var selected = root.querySelector('[data-tcvc-enquiry-colour-field]');
    if (page) page.value = titles.join(' | ');
    if (product) product.value = titles.join(' | ');
    if (sourceUrl) sourceUrl.value = urls.join(' | ');
    if (selected) selected.value = '';

    renderProducts(root, products);

    enquiryForm.dataset.rfOnlineEnquirySubmitted = '';
    enquiryForm.dataset.rfOnlineEnquirySubmitting = 'false';
    enquiryForm.dataset.rfOnlineEnquiryRequestId = '';

    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    var first = root.querySelector('input[name="contact[name]"]');
    if (first) window.setTimeout(function () { first.focus(); }, 50);
  }

  function closeMobileFilters() {
    var details = document.querySelector('.rf-tcv .mobile-facets__disclosure[open]');
    if (!details) return;
    var summary = details.querySelector(':scope > summary');
    if (summary) {
      summary.click();
    } else {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    }
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-tcvc-enquiry-toolbar]');
    if (open) {
      event.preventDefault();
      openModal();
      return;
    }

    var filterProxy = event.target.closest('[data-tcvc-filter-proxy]');
    if (filterProxy) {
      event.preventDefault();
      var mobileFilter = document.querySelector('.mobile-facets__open-wrapper');
      if (mobileFilter) mobileFilter.click();
      return;
    }

    var filterClose = event.target.closest('[data-tcvc-filter-close]');
    if (filterClose) {
      event.preventDefault();
      closeMobileFilters();
      return;
    }

    var mobileBackdrop = event.target.closest('.mobile-facets');
    if (mobileBackdrop && mobileBackdrop.closest('.rf-tcv') && !event.target.closest('.mobile-facets__inner')) {
      event.preventDefault();
      closeMobileFilters();
      return;
    }

    var contactProxy = event.target.closest('[data-tcvc-contact-proxy]');
    if (contactProxy) {
      event.preventDefault();
      var headerContact = document.querySelector('#header-cta-primary');
      if (headerContact) headerContact.click();
      return;
    }

    if (event.target.closest('[data-tcvc-enquiry-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-tcv-compare-toggle]')) {
      updateToolbarButton();
      return;
    }
    if (event.target.matches('[data-tcvc-enquiry-colour-options] input[type="checkbox"]')) {
      var root = modal();
      if (root) syncSelectedColours(root);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (modal() && !modal().hidden) {
      closeModal();
      return;
    }
    closeMobileFilters();
  });

  function updateStickyTop() {
    var root = document.querySelector('.rf-tcv');
    if (!root) return;

    document.documentElement.classList.remove('rf-tcvc-hide-header');

    var header = document.querySelector('.section-header');
    if (header) {
      header.classList.add('shopify-section-header-sticky');
      header.classList.remove('shopify-section-header-hidden', 'rf-tcvc-header-hidden');
    }

    var top = header ? Math.round(header.getBoundingClientRect().height) : 0;
    root.style.setProperty('--rf-tcv-sticky-top', top + 'px');
    root.style.setProperty('--rf-tcvc-sticky-actions-top', top + 'px');
  }

  var stickyResizeRaf = 0;
  function requestStickyTop() {
    if (stickyResizeRaf) return;
    stickyResizeRaf = window.requestAnimationFrame(function () {
      stickyResizeRaf = 0;
      updateStickyTop();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    updateToolbarButton();
    updateStickyTop();
    revealPostedSuccess();
  });
  document.addEventListener('shopify:section:load', function () {
    updateToolbarButton();
    updateStickyTop();
  });
  window.addEventListener('resize', requestStickyTop, { passive: true });

  document.addEventListener('rf:tcv-selection-change', updateToolbarButton);
})();